<ng-container *transloco="let t; prefix: scope">
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
    <bl-frontend-text-input
      [text]="t('businessArea')"
      (valueChange)="emitBusinessDetails()"
      [(ngModel)]="clientBusinessDetails.businessArea"
      [maxlength]="100"></bl-frontend-text-input>

    <div class="editor-cell">
      <app-calendar
        [label]="t('registrationDate')"
        inputId="registrationDate"
        [(selectedDate)]="clientBusinessDetails.registrationDate"
        [minSelectableDate]="minSelectableDate"
        [defaultDate]="null"
        (selectedDateChange)="emitBusinessDetails()"
        styleClass="w-full"></app-calendar>
    </div>

    <bl-frontend-textarea
      id="descriptionOfBusiness"
      (valueChange)="emitBusinessDetails()"
      [text]="t('descriptionOfBusiness')"
      [(ngModel)]="clientBusinessDetails.description"
      [maxLength]="1000"
      [rows]="5"
      class="md:col-span-2"></bl-frontend-textarea>

    <bl-frontend-textarea
      id="specialRules"
      (valueChange)="emitBusinessDetails()"
      [text]="t('specialRules')"
      [(ngModel)]="clientBusinessDetails.specialRules"
      [maxLength]="1000"
      [rows]="5"
      class="md:col-span-2"></bl-frontend-textarea>

    <bl-frontend-textarea
      id="otherImportantClientInfo"
      (valueChange)="emitBusinessDetails()"
      [text]="t('otherImportantClientInfo')"
      [(ngModel)]="clientBusinessDetails.otherInfo"
      [maxLength]="1000"
      [rows]="5"
      class="md:col-span-2"></bl-frontend-textarea>

    <bl-frontend-text-input
      [text]="t('bank')"
      (change)="emitBusinessDetails()"
      [(ngModel)]="clientBusinessDetails.bank"
      [maxlength]="100"></bl-frontend-text-input>

    <bl-frontend-text-input
      [text]="t('accountant')"
      (change)="emitBusinessDetails()"
      [(ngModel)]="clientBusinessDetails.accountant"
      [maxlength]="100"></bl-frontend-text-input>
  </div>
</ng-container>

<div style="height: 15px"></div>
<div class="flex justify-end items-end -m-5 -mb-7 mt-6 p-4 bg-bl-grey-100">
  <bl-frontend-button
    variant="secondary"
    class="mr-3"
    (onclick)="close(-1)"
    [text]="'shared.close' | transloco"></bl-frontend-button>
  <bl-frontend-button
    (onclick)="close(1)"
    [disabled]="clientBusinessDetails.archived || clientBusinessDetails.id === -1"
    [text]="'shared.save' | transloco">
  </bl-frontend-button>
</div>
